import Swiper from 'swiper'

export default (options = {}) => ({
    swiper: null,

    init() {
        this.$nextTick(() => {

            this.swiper = new Swiper(this.$refs.slider, {
                spaceBetween: options.spaceBetween ?? 20,
                watchOverflow: true,
                autoHeight: false,

                breakpoints: {
                    0: {
                        slidesPerView: options.perViewMobile ?? 2.2,
                    },
                    640: {
                        slidesPerView: options.perView640 ?? 3.2,
                    },
                    768: {
                        slidesPerView: options.perViewTablet ?? 4.2,
                    },
                    1024: {
                        slidesPerView: options.perView1024 ?? 5.2,
                    },
                    1280: {
                        slidesPerView: options.perViewDesktop ?? 6,
                        allowTouchMove: options.lockDesktop ?? false,
                    },
                },
            })
        })
    },

    prev() {
        this.swiper?.slidePrev()
    },

    next() {
        this.swiper?.slideNext()
    },
})
